import { types } from "../../types/types";
import { ESTADO_VALORIZACIONES_DISCAPACIDAD } from "../../utils/constants";

const initialState = {
  items: [],
  loading: false,
  activosPorFecha: ESTADO_VALORIZACIONES_DISCAPACIDAD.VIGENTES
};

export const NomencladorDiscapacidadReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.discapacidadValorizacionesTraerStart:
      return {
        ...state,
        loading: true,
        items: []
      };
    case types.discapacidadValorizacionesTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload
      };
    case types.discapacidadValorizacionesTraerError:
      return {
        ...state,
        loading: false,
      };
    case types.discapacidadValorizacionesSetActivosPorFecha: 
      return {
        ...state,
        activosPorFecha: action.payload
      }
    case types.discapacidadValorizacionesEditar: 
      return {
        ...state,
        items: state.items.map(valorizacion =>(
          valorizacion.idValorizacion === action.payload.idValorizacion
          ? {...valorizacion, valor: action.payload.valor} : valorizacion
      ))
    }
    default:
      return state;
  }
};
